<template>
  <path pid="0" d="M21.61 15.21a1 1 0 00-1.32.08L17 18.59V9a5 5 0 00-5-5H5a1 1 0 000 2h7.18A3 3 0 0115 9v9.59l-3.29-3.3a1 1 0 00-1.42 1.42l5 5 .11.09.08.05H16.36l.08-.05.09-.08 5-5a1 1 0 000-1.42zM18.84 20.62z"/>
</template>
